module.exports = __webpack_public_path__ + "img/مربع-وشش-ضلعی2.bb9dfcfb.png";